// From the pure schema entry of platform: this file is bundled into the web app through ./schema.
import { definePermissions } from '@mkcore/platform/schema';

/** Permissions of proposals (D18, CO-0595). Object scope comes on top: the grants of the organisation. */
export const proposalPermissions = definePermissions('proposals', {
  read: 'View proposals and their versions',
  create: 'Make proposals',
  update: 'Change proposals, their versions and lines, send them and record the decision of the client',
  delete: 'Delete a draft proposal that was never sent',
  approve: 'Approve the mail that sends a proposal to the client',
});
